import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setImageSrc } from "../features/image";
import { selectToken, setPlaceholder } from "../features/token";
import { selectBuyMode, setAmount, setBuyMode } from "../features/trade";
import { tokens } from "./data";

const BuyMode = () => {
    const buyMode = useAppSelector(selectBuyMode)
    const dispatch = useAppDispatch();
    const token = useAppSelector(selectToken);

    function setBuyOrSell() {
        if (buyMode) {
            dispatch(setPlaceholder('FACE'));
        } else {
            dispatch(setPlaceholder(tokens[token][0]));
        }
        dispatch(setBuyMode(!buyMode));
        dispatch(setAmount(''));
    }

    return (
        <button className="w-10 md:w-10 h-5 md:h-5 bg-white rounded-full flex items-center" onClick={setBuyOrSell}>
            {buyMode && <div className="h-[18px] w-[18px] ml-[1px] bg-[#595959] rounded-full"></div>}
            {!buyMode && <div className="h-[18px] w-[18px] bg-[#595959] rounded-full ml-5"></div>}
        </button>
    );
}
export default BuyMode;